import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _toConsumableArray from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Button, Center, HStack, Stack } from '@chakra-ui/react';
import React, { useState } from 'react';
import PriceCard from './pricing-card';
export default function Pricing(_ref) {
  var _ref$products = _ref.products,
      products = _ref$products === void 0 ? [] : _ref$products,
      onSelectPlan = _ref.onSelectPlan;

  var _useState = useState('month'),
      billingInterval = _useState[0],
      setBillingInterval = _useState[1];

  var handleOnSelect = function handleOnSelect(product) {
    return function () {
      if (onSelectPlan) onSelectPlan(product, billingInterval);
    };
  }; // Ordering the products list by the order field in the metadata (if exist)


  var ordered = _toConsumableArray(products);

  ordered.sort(function (a, b) {
    var _a$metadata, _b$metadata;

    var ao = (_a$metadata = a.metadata) === null || _a$metadata === void 0 ? void 0 : _a$metadata.order;
    var bo = (_b$metadata = b.metadata) === null || _b$metadata === void 0 ? void 0 : _b$metadata.order;
    if (ao && bo) return ao - bo;else return 0;
  });
  if (!products || !products.length) return /*#__PURE__*/_jsx("section", {
    className: "bg-black",
    children: /*#__PURE__*/_jsx("div", {
      className: "max-w-6xl mx-auto py-8 sm:py-24 px-4 sm:px-6 lg:px-8",
      children: /*#__PURE__*/_jsxs("p", {
        className: "text-6xl font-extrabold text-white sm:text-center sm:text-6xl",
        children: ["No subscription pricing plans found. Create them in your", ' ', /*#__PURE__*/_jsx("a", {
          className: "text-pink underline",
          href: "https://dashboard.stripe.com/products",
          rel: "noopener noreferrer",
          target: "_blank",
          children: "Stripe Dashboard"
        }), "."]
      })
    })
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Center, {
      children: /*#__PURE__*/_jsxs(HStack, {
        spacing: "10px",
        border: "1px",
        borderColor: "gray.200",
        p: 2,
        borderRadius: "5px",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return setBillingInterval('month');
          },
          backgroundColor: billingInterval === 'month' ? 'gray.400' : 'transparent',
          children: "Monthly billing"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return setBillingInterval('year');
          },
          backgroundColor: billingInterval === 'year' ? 'gray.400' : 'transparent',
          children: "Yearly billing"
        })]
      })
    }), /*#__PURE__*/_jsx(Stack, {
      direction: {
        base: 'column',
        md: 'row'
      },
      textAlign: "center",
      justify: "center",
      spacing: {
        base: 4,
        lg: 10
      },
      py: 10,
      children: ordered.map(function (product, i) {
        var _product$data, _product$data2, _product$data3;

        var price = product.prices.find(function (price) {
          return price.interval === billingInterval;
        });
        return /*#__PURE__*/_jsx(PriceCard, {
          amount: price.unit_amount,
          upperLabel: (_product$data = product.data) === null || _product$data === void 0 ? void 0 : _product$data.upperLabel,
          setupFee: (_product$data2 = product.data) === null || _product$data2 === void 0 ? void 0 : _product$data2.setupFee,
          onSelect: onSelectPlan ? handleOnSelect(product) : null,
          name: product.name,
          currency: price.currency,
          period: price.interval,
          label: price.trial_period_days ? "Start ".concat(price.trial_period_days, " days trial") : 'Choose Plan',
          features: (_product$data3 = product.data) === null || _product$data3 === void 0 ? void 0 : _product$data3.features
        }, i);
      })
    })]
  });
}